import Rx from 'rxjs';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';

import { request } from 'core/generalFunctions';
import * as reservasActions from 'modules/reservas/action';
import * as generalActions from 'modules/general/action';
import * as viajesActions from 'modules/viajes/action';
import * as abonadosActions from 'modules/abonados/action';
import * as penalizacionesActions from 'modules/penalizaciones/action';
import * as errorActions from 'modules/error/action';
import * as constAction from 'root/actionConstants';
import { change } from 'redux-form/immutable';
import { FORM_RESERVA } from 'modules/forms/formConstants';
import { Map, fromJS } from 'immutable';

const { ajax } = Rx.Observable;

export const setTemporalEpic = (action$, store) =>
  action$.ofType(constAction.RESERVAS_TEMPORAL_SET).switchMap((action) =>
    ajax(request(action))
      .map(() => store.dispatch(reservasActions.setState({ reservaLlena: false })))
      .catch((err) => {
        if (err.status == 457 && err.response.error.name == 'RESERVA_LLENA') store.dispatch(reservasActions.setState({ reservaLlena: true }));
        return errorActions.request(err, action);
      }),
  );

export const peticionReservaEpic = (action$, store) =>
  action$
    .ofType(constAction.RESERVAS_SET)
    .throttleTime(800)
    .switchMap((action) => {
      if (!action.payload.paradaBajada) delete action.payload.paradaBajada;
      return ajax(request(action))
        .mergeMap((result) => {
          if (result) return Rx.Observable.of(push(`/dashboard/reservas/pasajeros/${action.payload.viajeId}`)).concat(Rx.Observable.of(generalActions.snackbar_show('Reserva guardada')));
          else return Rx.Observable.of(generalActions.snackbar_show('Error al reservar'));
        })
        .catch((err) => {
          if (err.response && err.response.error) {
            if (err.response.error.name == 'RESERVAS_MAXIMAS_PERMITIDAS') {
              return Rx.Observable.of(reservasActions.setState({ showListaReservas: true })).concat(Rx.Observable.of(reservasActions.setState({ reservasPrevias: err.response.error.data })));
            } else if (err.response.error.name == 'PENALIZACION_PENDIENTE') {
              return Rx.Observable.of(penalizacionesActions.setState({ showListaPenalizaciones: true, penalizacionesUsuario: err.response.error.data }));
            }
          }
          return errorActions.request(err, action);
        })
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide()));
    });

export const deleteTemporalEpic = (action$, store) =>
  action$.ofType(constAction.RESERVAS_TEMPORAL_DELETE).switchMap((action) =>
    ajax(request(action))
      .mergeMap(() => Rx.Observable.empty())
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const deleteEpic = (action$, store) =>
  action$.ofType(constAction.RESERVAS_CANCELAR).switchMap((action) =>
    ajax(request(action))
      .mergeMap(() => {
        let acciones = [generalActions.snackbar_show('Reserva cancelada')];
        if (action.payload.reservaPrevia) acciones.push(reservasActions.delReservaPrevia(action.payload.reservaId));
        if (action.refreshAbonado) acciones.push(abonadosActions.getReservasUsuario(action.refreshAbonado.abonadoId, action.refreshAbonado.isUser));
        return acciones;
      })
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const concretarReservaEpic = (action$) =>
  action$.ofType(constAction.RESERVAS_CONCRETAR).switchMap((action) =>
    ajax(request(action))
      .mergeMap(() => [
        action.setInAbonados ? abonadosActions.getReservasUsuario(action.setInAbonados.abonadoId, action.setInAbonados.isUser) : viajesActions.getPasajeros(action.payload.viajeId),
        generalActions.snackbar_show(action.payload.concretada ? 'Reserva concretada' : 'Reserva no concretada'),
      ])
      .catch((err) => errorActions.request(err, action)),
  );

export const abonarReservaEpic = (action$) =>
  action$.ofType(constAction.RESERVAS_ABONAR).switchMap((action) =>
    ajax(request(action))
      .mergeMap(() => [viajesActions.getPasajeros(action.viajeId), generalActions.snackbar_show('Reserva modificada')])
      .catch((err) => errorActions.request(err, action)),
  );

export const getReservasByIdEpic = (action$) =>
  action$.ofType(constAction.RESERVAS_GET_BY_ID).switchMap((action) =>
    ajax(request(action))
      .flatMap(({ response }) => {
        if (response && response.reserva) {
          return Rx.Observable.of(
            reservasActions.setState({
              reserva: {
                ...response.reserva,
                acompanantes: response.acompanantes,
              },
            }),
          );
        } else return Rx.Observable.empty();
      })
      .catch((err) => errorActions.request(err, action)),
  );

export const getReservasPendientesEpic = (action$) =>
  action$.ofType(constAction.RESERVAS_GET_PENDIENTES).switchMap((action) =>
    ajax(request(action))
      .map(({ response }) => reservasActions.setState({ reservasPendientes: response }))
      .catch((err) => errorActions.request(err, action)),
  );

export const setReservaProbableEpic = (action$, store) =>
  action$.ofType(constAction.RESERVAS_SET_PROBABLES).switchMap((action) =>
    ajax(request(action))
      .mergeMap(({ response: { creada } }) => [generalActions.snackbar_show(creada ? 'Reserva creada' : 'No se pudo crear la reserva.')])
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

//--EPICS DE OTROS COMPONENTES -- //
export const getViajeByIdEpic = (action$, store) =>
  action$.ofType(constAction.RESERVAS_VIAJES_GET_BY_ID).switchMap((action) =>
    ajax(request(action))
      .mergeMap(({ response }) => {
        let actions = [reservasActions.setState({ viaje: response || {} })],
          viajeState = store.getState().getIn(['viajes', 'hoy']);
        if (!viajeState.find((v) => v.get('id') == response.id)) actions.push(viajesActions.setState({ hoy: viajeState.push(fromJS(response)) }));
        return actions;
      })
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getByDocEpic = (action$, store) =>
  action$.ofType(constAction.RESERVAS_PASAJEROS_GET_BY_DOCUMENTO).mergeMap((action) =>
    ajax(request(action))
      .flatMap(({ response }) => {
        if (!response) return Rx.Observable.of(change(FORM_RESERVA, 'usuario', Map({ documento: action.payload.documento, tipoDoc: 'DNI' })));
        return Rx.Observable.merge([
          change(FORM_RESERVA, 'usuario.nombre', response.nombre),
          change(FORM_RESERVA, 'usuario.apellido', response.apellido),
          change(FORM_RESERVA, 'usuario.telefono', response.telefono),
          change(FORM_RESERVA, 'usuario.documento', response.documento),
          change(FORM_RESERVA, 'usuario.usuarioId', response.usuarioId),
          change(FORM_RESERVA, 'usuario.abonadoId', response.abonadoId),
          change(FORM_RESERVA, 'usuario.tipoDoc', response.tipoDoc),
          change(FORM_RESERVA, 'usuario.usuarioCasualId', response.usuarioCasualId),
          reservasActions.setState({ pasajero: response }),
        ]);
      })
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export default combineEpics(
  deleteEpic,
  getByDocEpic,
  setTemporalEpic,
  getViajeByIdEpic,
  deleteTemporalEpic,
  peticionReservaEpic,
  getReservasByIdEpic,
  concretarReservaEpic,
  abonarReservaEpic,
  getReservasPendientesEpic,
  setReservaProbableEpic,
);



// WEBPACK FOOTER //
// src/modules/reservas/epics.js